import { Component, OnDestroy, ViewChild, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { Subscription, Observable } from 'rxjs'
import { Table } from 'primeng/table'
import { UiService } from 'src/app/services/ui.service'
import { AccountService } from '../../services/account.service'
import { ModalDialogComponent } from 'src/app/shared/modal-dialog/modal-dialog.component'
import { ApiService } from 'src/app/services/api.service'
import { AccessLevelService } from 'src/app/services/access-level.service'
import { RoleLoadingService } from 'src/app/services/role-loading.service'
import { FormValidationService } from 'src/app/services/form-validation.service'
import { AccountSubjectGroupDto } from 'src/app/services/dtos'
import { BaseGroupModal, RoleItem, UserItem } from '../shared/base-group-modal'
import { ModalService, ModalController } from '../../services/modal.service'

@Component({
  selector: 'app-new-group-modal',
  templateUrl: './new-group-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NewGroupModalComponent extends BaseGroupModal implements OnDestroy, ModalController {
  @ViewChild('newGroupModal') modal: ModalDialogComponent
  @ViewChild('rolesTable') rolesTable: Table
  @ViewChild('usersTable') usersTable: Table
  @Output() groupCreated = new EventEmitter<void>()

  constructor(
    protected formBuilder: FormBuilder,
    protected accountService: AccountService,
    protected uiService: UiService,
    protected apiService: ApiService,
    protected accessLevelService: AccessLevelService,
    protected roleLoadingService: RoleLoadingService,
    protected formValidationService: FormValidationService,
    private modalService: ModalService
  ) {
    super(
      formBuilder,
      accountService,
      apiService,
      uiService,
      accessLevelService,
      roleLoadingService,
      formValidationService
    )
    // Register with modal service
    this.modalService.register(this, this)
  }

  ngOnDestroy() {
    this.cleanup()
    // Unregister from modal service
    this.modalService.unregister(this)
  }

  open() {
    this.resetForm()
    this.loadRolesAndUsers().then(() => {
      this.modal.open()
    })
  }

  close() {
    this.modal.close()
    this.resetForm()
  }

  isModalOpen(): boolean {
    return this.modal && this.modal.isOpen
  }

  private resetForm() {
    this.groupForm.reset()
    this.resetSelections()
    this.saving = false
    if (this.saveSubscription) {
      this.saveSubscription.unsubscribe()
      this.saveSubscription = null
    }
  }

  // Abstract method implementations
  getSaveButtonText(): string {
    return this.saving ? 'Creating...' : 'Create Group'
  }

  performSave(groupData: any): Observable<any> {
    const groupDto: AccountSubjectGroupDto = {
      name: groupData.name,
      externalId: groupData.externalId || null,
      roles: groupData.roles,
      accountSubjects: groupData.accountSubjects,
    }
    return this.apiService.createAccountSubjectGroup(this.accountService.accountId, groupDto)
  }

  onSaveSuccess(result: any): void {
    this.groupCreated.emit()
    this.close()
  }

  customSort = this.accessLevelService.createAccessLevelSortFunction()

  filterRoles(event: any) {
    if (this.rolesTable) {
      this.rolesTable.filterGlobal(event.target.value, 'contains')
    }
  }

  filterUsers(event: any) {
    if (this.usersTable) {
      this.usersTable.filterGlobal(event.target.value, 'contains')
    }
  }
}
